import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "page-left" }
const _hoisted_3 = {
  key: 0,
  class: "page-titles"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("template", { name: "title" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "page-titles"
}
const _hoisted_7 = { class: "page-title" }
const _hoisted_8 = { class: "page-subtitle" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "page-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!!_ctx.$slots.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.title), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.subtitle), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
      (!!_ctx.$slots.left)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "left")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.$slots.actions)
        ? _renderSlot(_ctx.$slots, "actions", { key: 0 })
        : _createCommentVNode("v-if", true)
    ])
  ]))
}